@use "@inshared/ui-foundation/css/tokens/size";

web-icon,
web-ngicon {
    --icon-height: #{size.$icon-sm};
    --icon-width: #{size.$icon-sm};
    height: fit-content;
    width: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
        aspect-ratio: 1;
        height: var(--icon-height);
        width: var(--icon-width);
        max-width: fit-content;
    }
}
